export default [
  // discounts router
  {
    meta: {
      is_auth: true,
      is_admin: true,
      title: "Remises",
      layout: "dashboard",
    },
    path: "/discounts",
    name: "discounts",
    component: () => import("@/layouts/index/DiscountIndex.vue"),
    children: [
      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Liste des remises des clients",
          layout: "dashboard",
        },
        path: "customers/index",
        name: "discounts-index",
        component: () => import("@/views/discounts/Listing.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Créer un nouveau remise pour le client",
          layout: "dashboard",
        },
        path: "customers/create",
        name: "discounts-create",
        component: () => import("@/views/discounts/Create.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Modifier la remise",
          layout: "dashboard",
        },
        path: "customers/:reference/edit",
        name: "discounts-edit",
        component: () => import("@/views/discounts/Edit.vue"),
      },

      {
        meta: {
          is_auth: true,
          is_admin: true,
          title: "Détails d'un paiement",
          layout: "dashboard",
        },
        path: "customers/:reference/details",
        name: "discounts-details",
        component: () => import("@/views/discounts/Details.vue"),
      },
    ],
  },
];